/**
 * Buy Now Interceptor
 * Intercepts "Buy It Now" clicks for non-logged-in users.
 * triggers the login modal, and resumes the flow after login.
 */

(function () {
    'use strict';

    // 1. Intercept Click (Capture Phase)
    document.addEventListener('click', function (e) {
        // Look for the Shopify Payment Button (Buy Now)
        // We use closest() to catch clicks on inner elements (spans, svgs)
        const buyNowBtn = e.target.closest('.shopify-payment-button__button');

        // If it is a buy now button AND user is NOT logged in
        if (buyNowBtn && !window.customerLogged) {
            // Stop everything
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            console.log('Buy Now intercepted: User not logged in.');

            // Store intent
            sessionStorage.setItem('pendingBuyNow', 'true');

            // Open Login Modal
            if (window.openAuthModal) {
                window.openAuthModal('login');
            } else {
                console.error('Auth Modal not found! Redirecting to login fallthrough.');
                window.location.href = '/account/login';
            }

            return false;
        }
    }, true); // Use Capture phase to get it before other listeners

    // 2. Resume Flow on Load (if logged in & pending)
    document.addEventListener('DOMContentLoaded', function () {
        if (window.customerLogged && sessionStorage.getItem('pendingBuyNow') === 'true') {
            console.log('Resuming pending Buy Now flow...');
            sessionStorage.removeItem('pendingBuyNow');

            // Find the Buy Now button
            // We retry a few times in case it's dynamically loaded (like smart buttons)
            let attempts = 0;
            const maxAttempts = 10;

            const tryClick = setInterval(() => {
                attempts++;
                const btn = document.querySelector('.shopify-payment-button__button');

                // Ensure it's not disabled
                if (btn && !btn.disabled) {
                    console.log('Buy Now button found. Clicking...');
                    clearInterval(tryClick);

                    // Force click
                    // NOTE: standard click() works for unbranded buttons.
                    // For wallet buttons (PayPal/Apple), this might not work due to security,
                    // but it's the best effortless attempt we can make.
                    btn.click();
                }

                if (attempts >= maxAttempts) {
                    console.log('Buy Now button not found or ready after max attempts.');
                    clearInterval(tryClick);
                }
            }, 500);
        }
    });

})();
